import { MPM_CAPACITE_VERSION, MPM_PREAUT_VERSION } from '../../configs/toggles.config';
import { ToggleCondition } from '../lib-feature-decision/conditions/toggle-condition';

export namespace ParcoursDsdFeatures {
  export const CapaciteLivraisonExperimenteEnabled = new ToggleCondition([
    MPM_CAPACITE_VERSION.Disabled,
    MPM_CAPACITE_VERSION.Experimente
  ]);

  export const CapaciteDisabled = new ToggleCondition(MPM_CAPACITE_VERSION.Disabled);

  export const PreautorisationDisabled = new ToggleCondition(MPM_PREAUT_VERSION.Disabled);
}
